// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_9cadcb71c3--tooltip--Hs2ji"};